/* eslint-disable no-unused-vars */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import routes from './routes'

const waitForStorageToBeReady = async (to, from, next) => {
  await store.restored
  const isLoggedIn = store.getters['getisLoggedIn']
  if (to.path == '/logout' && !isLoggedIn) {
    next({
      name: 'Login'
    })
    return
  }
  if (to.matched.some(route => route.meta.beforelogin) && isLoggedIn) {
    const myrole = store.getters["auth/getRole"];
    next({
      name: (myrole == 'aln' || myrole == 'mhs') ? 'Profile' : 'Dashboard'
    })
    return
  }
  next()
}
const setRouter = async (routes) => {
  const data = await routes
  Vue.use(VueRouter)
  const router = new VueRouter({
    mode: 'history',
    base: process.env.VUE_APP_PATH,
    routes: data,
    scrollBehavior (to, from, savedPosition) {
      // if(to.name == 'InvestorRelationship'){
      //   return savedPosition
      // }
      if (to.hash) {
        return {
          x: 0, 
          y: 0,
          behavior: 'smooth',
        }
      }
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ x: 0, y: 0,  behavior: 'smooth'})
        }, 50)
      })
    }
  })
  router.beforeEach(waitForStorageToBeReady)
  return router
}
export default setRouter(routes)